export default "/fonts/vendor/@fontsource/lato/files/lato-latin-100-normal.woff?7e10bec004028a60eaa7c69410fd9958";